/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".remove-link[_ngcontent-%COMP%]{padding-left:10px;font-style:italic;font-size:13px;cursor:pointer}"];
export { styles as styles };
